export const formatAddressByLines = (addressLine1: string, addressLine2: string) => {
	const addressLine1Array = addressLine1.split('|');
	const addressLine1ArrayLength = addressLine1Array.length;
	let addressLine1String = '';
	addressLine1Array.forEach((address, index) => {
		addressLine1String += address;
		if (index < addressLine1ArrayLength - 1) {
			addressLine1String += ' ';
		}
	});
	return `${addressLine1String}, ${addressLine2}`;
};

export const isValidAddressByLines = (addressLine1: unknown, addressLine2: unknown) => {
	if (typeof addressLine1 !== 'string' || typeof addressLine2 !== 'string') {
		return false;
	}

	const REGEX = /^[a-zA-Z0-9\s\.\,\#\-\|]+$/;
	return REGEX.test(addressLine1) && REGEX.test(addressLine2);
};
